module.exports = __webpack_public_path__ + "img/api.e9be0690.png";